export default {
    path: 'serve_clause',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('./ServeClause').default)
        })
    }
}
